var React = require('react');

function AboutUsBannerIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.999998 3.91901e-06L1 22L54 22","stroke":"#FCB34E","strokeWidth":"2"}));
}

AboutUsBannerIcon.defaultProps = {"width":"54","height":"23","viewBox":"0 0 54 23","fill":"none"};

module.exports = AboutUsBannerIcon;

AboutUsBannerIcon.default = AboutUsBannerIcon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/about-us-banner-icon.svg
// module id = 1168
// module chunks = 0